import CategoryRepository from '@/shared/http/repositories/socialProject/category'
import { loading, toast } from '@/shared/utils/UIHelper'
import { IsSuccessCode } from '@/shared/utils/API'
import * as mutation from './mutationTypes'
import { actionTypes as action } from './actionTypes'

export const actions = {
  [action.FETCH_CATEGORIES]: async ({ commit }, modalityId) => {
    try {
      loading.push()

      const res = await CategoryRepository.GetAllByModality(modalityId)
      if (!IsSuccessCode(res)) Promise.reject()

      commit(mutation.SET_CATEGORIES, res.data.data)
      loading.pop()
      return Promise.resolve()
    } catch (error) {
      loading.pop()
      toast.error('Não foi possível carregar a lista de Categorias.', 'ERRO')
    }
  }
}
